export const colors = {
  navy: {
    n950: '#000000',
    n900: '#17191a',
    n800: '#1e2122',
    n700: '#26292b',
    n600: '#515455',
    n400: '#757779',
    n200: '#b6b6b5',
    n100: '#dfdfdf',
    n050: '#f2f6f6',
  },
  orange: {
    o900: '#0e3e4a',
    o700: '#114c59',
    o500: '#145969',
    o400: '#377280',
    o300: '#5b8b96',
    o100: '#e2f5f3',
    o050: '#f2f6f6',
  },
  neutral: {
    g950: '#26292b',
    g800: '#3f4142',
    g700: '#757779',
    g600: '#8d9499',
    g400: '#b6b6b5',
    g300: '#cbcbcb',
    g250: '#E4E4E7',
    g200: '#dfdfdf',
    g100: '#f2f6f6',
    g050: '#f2f6f7',
    /** Светлый фон шапок таблиц и панелей */
    g025: '#f4f4f5',
    white: '#ffffff',
  },
  status: {
    ok: '#3ca94e',
    warn: '#c47a15',
    err: '#c5352f',
    info: '#1a73c2',
  },
} as const;
